import React from "react";
interface Props {
  isExpired: boolean;
  isRewardsCard: boolean;
  type: string;
  mask: string;
  name: string;
}
const SavedCard = ({
  isExpired,
  isRewardsCard,
  type,
  mask,
  name
}: Props) => {
  const isCreditCard = type.length > 0;
  const paymentType = isRewardsCard ? "Rewards" : type;
  return isCreditCard ? <>
      <span className={`credit-icon credit-icon--${paymentType.toLowerCase().replace(" ", "")}-sm p-0`}>
        {paymentType}
      </span>
      <span className="inline-block text-[11px] text-left leading-none ml-2">
        <strong>{mask}</strong>
        {isExpired && <span className="text-red-500 pl-1">EXP</span>}
        <br />
        {name}
      </span>
    </> : <span className="inline-block text-[11px] leading-none py-1 ml-2 m-0" data-sentry-component="SavedCard" data-sentry-source-file="SavedCard.tsx">
      Select A Card
    </span>;
};
export default SavedCard;